import { displayDefaultDateTime } from 'app/shared/util/date-utils';
import dayjs from 'dayjs';

export const columns = [
  {
    title: 'Tên kỳ báo cáo',
    key: 'name',
    sorter: true,
    dataIndex: 'name',
  },
  {
    title: 'Thời hạn báo cáo',
    key: 'reportDate',
    sorter: true,
    dataIndex: 'reportDate',
    render: item => displayDefaultDateTime(item),
  },
];

export const yearOptions = Array.from({ length: 5 }, (_, i) => (dayjs().year() - 1) + i);
